import { render, staticRenderFns } from "./user-data.vue?vue&type=template&id=95a52546&scoped=true&"
import script from "./user-data.vue?vue&type=script&lang=js&"
export * from "./user-data.vue?vue&type=script&lang=js&"
import style0 from "./user-data.vue?vue&type=style&index=0&id=95a52546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a52546",
  null
  
)

export default component.exports